export const POPUP_HEIGHT = {
    MEDIUM: '55%',
    LARGE: '75%',
    FULL: '100%',
};
